import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MiscService {
  openPremium() {
    window.open('/personal-subscription', '_blank');
  }
  deepMergeObjects(target: { [x: string]: any }, source: { [x: string]: any }) {
    Object.keys(source).forEach((key) => {
      if (source[key] && typeof source[key] === 'object') {
        target[key] = target[key] || {};
        this.deepMergeObjects(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
    return target;
  }
}
